module.exports = __webpack_public_path__ + "img/img8.01b4912e.jpg";